// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';
import { TimeEntryImportBill } from './time-entry-import-bill';
import { TimeEntryImportDetail } from './time-entry-import-detail';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TimeEntryImportBillDetail extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  billedTotal!: number;
  createdAt!: Date;
  createdBy?: string;
  timeEntryImportBillId!: number;
  timeEntryImportDetailId!: number;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  writeOffTotal?: number;
  timeEntryImportBill!: TimeEntryImportBill;
  timeEntryImportDetail!: TimeEntryImportDetail;
}

